export default __webpack_public_path__ + "static/media/contact_banner.f3e4b402.png";